import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useForm } from '@inertiajs/vue3';
    import TaskForm from './TaskForm.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import type { Company } from '@/types';
    import { Button } from '@/components/ui/button';
    import { DialogFooter, DialogClose } from '@/components/ui/dialog';
    import { useI18n } from 'vue-i18n';
    import Permission from '@/enums/Permission';
    import { usePermissions } from '@/composables/usePermissions';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateTask',
  props: {
    company: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();
    const { hasAnyPermission } = usePermissions();

    const form = useForm({
        company_id: props.company.id,
        task_title: '',
        task_description: '',
        deadline: '',
        weekdays: [],
        task_status: 'Open',
        send_notification: 0,
        notification_recurring_week: '0',
        notification_recurring_even_week: '1',
        notification_recurring_start_of_month: '1',
        responsible_ids: [],
        filename: null,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.dashboard.tasks.create'),
    "query-key": [_unref(QueryKey).DASHBOARD_TASKS, props.company.id],
    title: "dashboards.tasks_create",
    "button-text": "dashboards.tasks_create",
    "submit-text": "dashboards.tasks_create"
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogClose), { "as-child": "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                variant: "outline",
                size: "sm",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(form).resetAndClearErrors()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('forms.cancel')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (
                        _unref(hasAnyPermission)([
                            _unref(Permission).DASHBOARD_ADMIN_CREATE,
                            _unref(Permission).DASHBOARD_ADMIN_UPDATE,
                        ])
                    )
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                disabled: _unref(form).processing,
                loading: _unref(form).processing,
                size: "sm",
                variant: "default"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('dashboards.tasks_create')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(TaskForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})